import { render, staticRenderFns, recyclableRender, components } from "./u-message-input.vue?vue&type=template&id=1817e481&scoped=true&"
var renderjs
import script from "./u-message-input.vue?vue&type=script&lang=js&"
export * from "./u-message-input.vue?vue&type=script&lang=js&"
import style0 from "./u-message-input.vue?vue&type=style&index=0&id=1817e481&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817e481",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-message-input/u-message-input.vue"
export default component.exports